import { render, staticRenderFns } from "./CompanyDistrictList.vue?vue&type=template&id=72bd5236&"
import script from "./CompanyDistrictList.vue?vue&type=script&lang=ts&"
export * from "./CompanyDistrictList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports